import { render } from "./ProductItemsTable.vue?vue&type=template&id=227c1e0a"
import script from "./ProductItemsTable.vue?vue&type=script&lang=js"
export * from "./ProductItemsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__